<template>
    <div class="bgmain">
        <div class="fir"><img src="./fir.png"></div>
        <div v-if="original">
            
        <div class="question computed">来算算还有比我手续费更低的吗？</div>
        <div class="input"><input v-model="contract" placeholder="请输入品种全称/交易代码/合约代码" /></div>
        <div class="button">
            <button @click="searchBee">查询手续费</button>
        </div>
        <div class="text">
            <p>本计算价格使用该品种合约上一交易日的结算价。</p>
            <p>信息仅供参考，具体费率以交易所为准。</p>
        </div>
        
        </div>
        <div v-if="!original" class="parts">
            <img src="./success.png" />
        </div>
        <div class="parts"><img src="./onepart.png"></div>
        <div class="parts"><img src="./twopart.png"></div>
        <div v-if="original">
            
    <form id="form" method="post" onsubmit="return false" action="##" >
        <div class="question">赶紧输入信息，领取资格吧</div>
        <div class="inputs"><input v-model="clientName" @input="clientName=clientName.replace(/[^\u4E00-\u9FA5]/g,'')"  placeholder="请输入真实姓名"/>
        <img src="./peo.png"/></div>
        <div class="inputs"><input v-model="mobile" placeholder="请输入手机号码"/>
        <img src="./tel.png"/></div>
        <div class="inputs"><input v-model="code"/>
        <img src="./chat.png"/>
        <button class="getVerCode" v-if="verifyMsg!='获取验证码'">{{ verifyMsg }}</button>
        <button class="getVerCode" v-else @click="getVerCode">{{ verifyMsg }}</button></div>
        <div class="submittext">提交成功后，工作人员会尽快与您联系。</div>
        <div class="button">
            <button @click="apply">立即申请</button>
        </div>
</form>
    </div>
        <div class="parts lpart"><img src="./lpic.png" /></div>
        <div class="model" v-if="showInfo" @click="closeModel">
            <div class="main" @click.stop="stopMP">
                <div class="title">东航期货开户交易手续费</div>
                <div class="blue">
                    <div class="leftInfo">合约：{{contractInfo.instrumentidupper}}</div><div class="rightInfo">昨结算价：{{contractInfo.settlementprice}}</div>
                </div>
                <div class="mainInfo">
                    <div class="plus">交易所手续费+投资者保障基金<span class="redspan">+1分钱</span></div>
                    <p><span>开仓</span><span>{{kc}}</span></p>
                    <p><span>平仓</span><span>{{pc}}</span></p>
                    <p><span>平今仓</span><span>{{pjc}}</span></p>
                </div>
                <div class="modelInputs">
                    <p>赶紧输入信息，领取资格吧</p>
                <div class="inputs"><input v-model="clientName"  @input="clientName=clientName.replace(/[^\u4E00-\u9FA5]/g,'')" placeholder="请输入真实姓名"/>
                    <img src="./peo.png"/></div>
                    <div class="inputs"><input v-model="mobile" placeholder="请输入手机号码"/>
                    <img src="./tel.png"/></div>
                    <div class="inputs"><input v-model="code"/>
                    <img src="./chat.png"/>
                    <button class="getVerCode" v-if="verifyMsg!='获取验证码'">{{ verifyMsg }}</button>
                    <button class="getVerCode" v-else @click="getVerCode">{{ verifyMsg }}</button></div>
                    <div class="buttonApply">
                        <button @click="apply">立即领取</button>
                    </div>
                    </div>
            </div>
        </div>
    <alert :showModal.sync="showAlert">{{ alertMessage }}</alert>
    </div>
</template>
<script>
    /* eslint-disable */
    import ajax from '@/common/ajax/ajax'
import alert from "@/components/alert/alert";
    export default {
      data () {
        return {
          contract: '',
          clientName: '',
          code: '',
          mobile: '',
          original: true,
          alertMessage:"",
      showAlert: false,
      showInfo: false,
      verifyMsg: "获取验证码",
      wait:30,
      contractInfo:{},
      tzzbzj:0,
      kc:0,
      pc:0,
      pjc:0
        }
      },
  components: { alert },
      mounted () {

      },
      methods: {
            multiNum(val) {
                return (isNaN(Number(val))?0:val)
            },
        closeModel() {
            this.showInfo = false
        },
        stopMP() {},
        getVerCode () {
            if(!this.mobile) {
                
                this.alertMessage = '请输入手机号码'
            this.showAlert = true;
            return
            }
          var info = {
            mobile: this.mobile
          }
          ajax.sendCodeLhsx(info).then(
            data => {
              if (data.data.resultStatus === '0') {
                  this.alertMessage = data.data.resultMessage
            this.showAlert = true;
      this.time()
              } else {
                  
                this.alertMessage = data.data.resultMessage
            this.showAlert = true;
              }
            }
          ).catch((err)=>{
          this.alertMessage = "发送失败"
          this.showAlert = true
         }) 
        },
        
        time () {
        if (this.wait === 0) {
          this.verifyMsg = '获取验证码'
          this.wait = 30
        } else {
          this.verifyMsg = this.wait + '秒后重新发送'
          this.wait--
          setTimeout(()=> {
            this.time()
          }, 1000)
        }
      },
        apply () {
          if (!this.clientName||this.clientName.length<2) {
            this.alertMessage = "请输入真实姓名";
            this.showAlert = true;
            return;
          }
          var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/; //11位手机号码正则
          if (!reg_tel.test(this.mobile)) {
            this.alertMessage = "请输入正确的手机号码";
            this.showAlert = true;
            return;
          }
          if (!this.code) {
            this.alertMessage = "验证码不能为空";
            this.showAlert = true;
            return;
          }
          let key = "907b067cd20ff4d0e7b928b0a1029b2a";
          var formData = {
            channel:"0",
            clientName: this.clientName,
            clientMobile: this.mobile,
            code: this.code,
            proID:this.$route.query.proID
          }
          let senddata = this.utils.encrypt(JSON.stringify(formData), key);
          ajax.loginLhsx(senddata).then((data) => {
            console.log(data)
          if(data.data.resultStatus == 0 ) {
            // console.log(data.data.data.needBack)
              this.showInfo = false
            this.original = false
            document.documentElement.scrollTop = 0
            if(this.$route.query.JLHC=='Y'&&data.data.data.needBack==1) {
                
            _baq.track("form", { assets_id: "1718993718948871"})
            // this.alertMessage = "已回传";
            // this.showAlert = true;
            }
          } else {
            this.alertMessage = data.data.resultMessage
            this.showAlert = true
            }
        }).catch((err)=>{
          // this.alertMessage = err
          // this.showAlert = true
          alert(err)
         }) 
        },
        searchBee () {
            if(!this.contract) {
          this.alertMessage = "请输入品种全称/交易代码/合约代码"
          this.showAlert = true
          return
            }
          ajax.publicGetExchcommrateByContract(this.contract).then(
            data => {
              if (data.data.resultStatus === '0') {
                  this.showInfo = true
                  this.contractInfo = data.data.data
                    // 投资者保障金=0.00000006*昨结算价*合约乘数*交易手数*
                    this.tzzbzj = 0.00000006*this.multiNum(this.contractInfo.settlementprice)*this.multiNum(this.contractInfo.volumemultiple)*1;
                  if(this.contractInfo.feetype==1) {
                    this.kc =(this.multiNum(this.contractInfo.settlementprice)*this.multiNum(this.contractInfo.openratiobymoney)*this.multiNum(this.contractInfo.volumemultiple)+this.tzzbzj+0.01).toFixed(2)
                    this.pc=(this.multiNum(this.contractInfo.settlementprice)*this.multiNum(this.contractInfo.closeratiobymoney)*this.multiNum(this.contractInfo.volumemultiple)+this.tzzbzj+0.01).toFixed(2)
                    this.pjc=(this.multiNum(this.contractInfo.settlementprice)*this.multiNum(this.contractInfo.closetodayratiobymoney)*this.multiNum(this.contractInfo.volumemultiple)+this.tzzbzj+0.01).toFixed(2)
                  } else if(this.contractInfo.feetype==2) {
                    this.kc =(this.multiNum(this.contractInfo.openratiobyvolume)+this.tzzbzj+0.01).toFixed(2)
                    this.pc = (this.multiNum(this.contractInfo.closeratiobyvolume)+this.tzzbzj+0.01).toFixed(2)
                    this.pjc =(this.multiNum(this.contractInfo.closetodayratiobyvolume)+this.tzzbzj+0.01).toFixed(2)
                  }
                // this.original = false
              } else {
                  
          this.alertMessage = data.data.resultMessage
          this.showAlert = true
              }
            }
          ).catch((err)=>{
          this.alertMessage = "查询失败"
          this.showAlert = true
         })
        }
      }
    }
</script>
<style lang="stylus" rel="stylesheet/stylus">
.bgmain
  position relative
  background url(./bg.png) no-repeat
  background-size cover
  .fir
    img
      width 100%
  .question
    text-align center
    color #ffdf56
    margin 20px 0 10px 0
    font-size 20px
    letter-spacing 3px
  .computed
    padding-top 15px
  .input
    text-align center
    input::-webkit-input-placeholder
      color #bebebe
    input
      height 40px
      line-height 40px
      padding-left 10px
      width 88vw
      letter-spacing 2px
      font-size 16px
      margin-bottom 20px
      border none
  .button
    text-align center
    button
      background #fed93e
      width 140px
      height 40px
      line-height 40px
      color #e12804
      font-size 16px
      border none
      box-shadow 2px 2px #fff
      margin-bottom 15px
  .text
    color #ffffff
    text-align center
    letter-spacing 1px
    font-size 14px
    margin-bottom 10px
    p
      height 25px
      line-height 25px
      margin 0
  .parts
    padding-top 10px
    img
      width 100%
  .inputs
    position relative
    text-align center
    margin-top 25px
    input::-webkit-input-placeholder
      color #bebebe
    input
      width 88vw
      padding-left 10vw
      height 40px
      line-height 40px
      border none
      box-shadow 2px 2px #ffc600
      letter-spacing 1px
      outline none
    img
      width 7vw
      position absolute
      left 8vw
      top 8px
    .getVerCode
      position absolute
      font-size 4vw
      height 36px
      line-height 36px
      top 2px
      width 30vw
      right 7vw
      background #1a5de3
      color #ffffff
      border none
      margin 0
      padding 0
  .submittext
    text-align center
    margin 15px 0
    color #ffdf56
    font-size 16px
  .lpart
    padding-bottom 30px
  .model
    position fixed
    left 0
    right 0
    top 0
    bottom 0
    background rgba(0,0,0,.5)
    .main
      position absolute
      width 96vw
      background #ffffff
      padding 2vw
      border-radius 3px
      top 50%
      left 2vw
      transform translateY(-50%)
      .title
        text-align center
        font-size 20px
        letter-spacing 3px
        margin-top 10px
        color #313131
      .blue
        background #1a5de3
        height 35px
        line-height 35px
        color #ffffff
        margin 5px 0 15px 0
        .leftInfo
          display inline-block 
          width 50%
          text-align center
        .rightInfo
          display inline-block 
          width 50%
          text-align center
      .mainInfo
        text-align center
        margin 10px 0
        .plus
          margin 20px 0
          .redspan
            color #b00100
            margin-left 0
        p
          width 60%
          margin 5px auto
          span
            display inline-block
            margin-left 0
            width 50%
      .modelInputs
        margin-top 20px
        p
          text-align center
          font-size 18px
          color #cb0914
        .inputs
          position relative
          text-align center
          margin-top 15px
          input::-webkit-input-placeholder
            color #bebebe
          input
            width 80vw
            padding-left 10vw
            height 40px
            line-height 40px
            border solid 1px #ddd
            box-shadow none
            letter-spacing 1px
            outline none
          img
            width 7vw
            position absolute
            left 8vw
            top 6px
          .getVerCode
            position absolute
            font-size 4vw
            height 32px
            line-height 32px
            top 4px
            width 30vw
            right 7vw
            background #1a5de3
            color #ffffff
            border none
            margin 0
            padding 0
        .buttonApply
            margin-top 20px
            text-align center
            padding-bottom 20px
            button
              width 80vw
              height 40px
              line-height 40px
              background #1a5de3
              border none
              color #ffffff
</style>



// WEBPACK FOOTER //
// index.vue?02366256